export const mapFetchStoreInformationResponse = (response) => {
  const app = {
    id: response["Aplicativo"]["Id"],
    name: response["Aplicativo"]["Nome"]
  }
  return {
    id: response["Id"] ?? null,
    app: app,
    primaryColor: response["CorPrimaria"],
    secondaryColor: response["CorSecundaria"],
    storeName: response["NomeEstabelecimento"],
    storeLogo: response["Logo"],
    flags: {
      ErpVoceQpad: response["ErpVoceQpad"],
      ErpEcomanda: response["ErpEcomanda"],
      ErpBematech: response["ErpBematech"],
      Delivery: response["Delivery"],
      Giraffas: response["Giraffas"],
      Kilo: response["Kilo"],
      Colibri: response["Colibri"]
    }
  }
}

export const mapFetchStoreMultistoreResponse = (response) => {
  return {
    primaryColor: response["CorPrimaria"],
    secondaryColor: response["CorSecundaria"],
    stores: response["Estabelecimentos"].map((store) => ({
      id: store["Id"],
      name: store["NomeFantasia"],
      baseToReplicateItems: store["BaseReplicaItens"],
    })),
    logo: response["Logo"],
    name: response["Nome"]
  }
}
